module.exports = __webpack_public_path__ + "static/media/IoT-电机驱动.5cd704f5.jpg";